import React from 'react';
import i18n from 'i18next';
import styles from './EnrollmentSearchingForAccount.module.scss';
import { Spot, SpotIcon } from '../../../Spot';

function EnrollmentSearchingForAccount(): React.JSX.Element {
  return (
    <div className={styles.container} data-automation-id={'searchingForAccountSpinner'}>
      <div className={styles.text}>
        <div className={styles.spinnerContainer}>
          <SpotIcon
            title={'spinner'}
            iconName={Spot.icons.spinner}
            data-automation-id={'findingPracticeLoadingSpinner'}
            className={'spot-loading-spinner spot-loading-spinner--large'}
          />
        </div>
        <div data-automation-id={'enrollmentSearchingAccountTitle'}>{i18n.t('locatingAccount')}</div>
      </div>
    </div>
  );
}

export default EnrollmentSearchingForAccount;
